import instance from "../axios";

export const getAll = async () => {
  const response = await instance.get(`users`);
  return response.data;
};
export const getDropdown = async () => {
  const response = await instance.get(`users/dropdown`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`users`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`users`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`users/` + id);
  return response;
};
